let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPH0z")).then(() => parcelRequire('kuFA7'));